"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrateRelayEnvironment = exports.getWiredSerializedState = void 0;
function getWiredSerializedState() {
    return window.__wired__;
}
exports.getWiredSerializedState = getWiredSerializedState;
function hydrateRelayEnvironment(env) {
    const serializedState = getWiredSerializedState();
    if (serializedState === null || serializedState === void 0 ? void 0 : serializedState.payload) {
        env.commitPayload(serializedState.operationDescriptor, serializedState.payload.data);
    }
}
exports.hydrateRelayEnvironment = hydrateRelayEnvironment;
